<template>
  <iframe
    v-if="iframePath"
    class="iframe"
    :src="iframePath"
    frameborder="0" />
</template>

<script>

export default {
  name: 'CrmWebview', // 外链测试页面
  components: {},
  props: {
    iframePath: {
      type: String,
      default: 'https://admin.lanhanba.net/#/crm/contact/detail?id=106662'
    }
  },
  data() {
    return {
    }
  },
  mounted() {},
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.iframe {
  width: 100%;
  height: calc(100vh - 244px);
}
</style>
